class Game {
  constructor(game, { isGameFavorite, demoModeDisabled }) {
    this.id = game.id;
    this.disabled = game.disabled;
    this.providerId = game.providerId;
    this.title = game.title;
    this.description = game.description;
    this.demo = game.demo && demoModeDisabled !== true;
    this.new = game.new;
    this.fullscreen = game.fullscreen;
    this.allowMaximize = game.fullscreen;
    this.width = game.width;
    this.height = game.height;
    this.linkUuid = game.linkUuid;
    this.productDisplayId = game.productDisplayId;
    this.aggregateTitle = game.aggregateTitle;
    this.code = game.code;
    this.groups = game.groups;
    this.subgroups = game.subgroups;
    this.favorite = isGameFavorite;
    this.url = '';
    this.resolving = false;
    this.provider = {};
    this.position = game.position;
    this.sticker = game.sticker;
    this.swimLane = game.swimLane || '';
    this.image = game.image;
  }

  getUrl({ demo, user, tenant, referrerUrl, language }) {
    return this.provider.getUrl({
      game: this,
      demo,
      user,
      tenant,
      referrerUrl,
      language,
    });
  }

  setUrl(url) {
    this.url = url;
  }

  setProvider(providers) {
    this.provider = providers.find((provider) => provider.id === this.providerId);
  }

  setOrder(order) {
    this.order = order;
  }

  setResolving(isResolving) {
    this.resolving = isResolving;
  }

  setFavorite(isFavorite) {
    this.favorite = isFavorite;
  }
}

export default Game;
